import React from "react";
import FetchHelper from "./lib/fetchHelper";
import { PasswordStrengthComponent } from "./PasswordStrengthComponent";
import { repeatMismatch } from "./lib/passwordFields";
import { ReactRenderer } from "./lib/ReactRenderer";
const state_login = 'login';
const state_userentry = 'userentry';
const state_onetimecode = 'onetimecode';
const state_newpassword = 'newpassword';
const state_passwordchanged = 'passwordchanged';
// The boards "Log ind" and "Glemt password - ...": one title above a card, the state in the card.
const titles = {
    [state_login]: 'Log ind',
    [state_userentry]: 'Angiv brugernavn',
    [state_onetimecode]: 'Angiv engangskode',
    [state_newpassword]: 'Angiv nyt password',
    [state_passwordchanged]: 'Password ændret'
};
const WarningIcon = () => (React.createElement("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
    React.createElement("path", { d: "M12 4 3 20h18z" }),
    React.createElement("path", { d: "M12 10v4M12 17h.01" })));
// The grey box that says what the step is about.
const Info = ({ children }) => (React.createElement("div", { className: "bi-lg-info" }, children));
// The arrow that goes on to the next step, next to the field; a spinner while it waits for the server.
const Go = ({ busy, disabled, onClick }) => (React.createElement("button", { type: "button", className: "bi-lg-go", "aria-label": "Forts\u00E6t", onClick: onClick, disabled: disabled }, busy
    ? React.createElement("i", { className: "fas fa-spinner fa-pulse no-text", "aria-hidden": "true" })
    : React.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
        React.createElement("path", { d: "M5 12h14M13 6l6 6-6 6" }))));
const Back = ({ onClick }) => (React.createElement("button", { type: "button", className: "bi-lg-back", onClick: onClick },
    React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
        React.createElement("path", { d: "m15 6-6 6 6 6" })),
    "Tilbage"));
export default class LoginComponent extends React.Component {
    constructor(props) {
        super(props);
        this.loginFormRef = React.createRef();
        this.newPasswordRef = React.createRef();
        this.state = {
            state: state_login,
            busy: false,
            username: { valid: false, value: '' },
            onetimecode: { valid: false, value: '' },
            newpassword: { valid: false, value: '' },
            repeatpassword: { valid: false, value: '' }
        };
    }
    componentDidMount() {
        var _a;
        this.formElem = document.getElementById('loginform').firstElementChild;
        (_a = this.loginFormRef.current) === null || _a === void 0 ? void 0 : _a.appendChild(this.formElem);
    }
    transitionTo(newState, additionalStateValues = {}) {
        this.setState(Object.assign({ state: newState }, additionalStateValues));
    }
    // Back to a fresh login form. Not location.reload(): after a refused login the page is the
    // answer to that POST, and reloading it submits the refused login once more, so the volunteer
    // who has just chosen a new password is met by "forkert" before typing anything.
    reset() {
        location.assign(location.pathname + location.search);
    }
    loginState() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: this.loginFormRef }),
            React.createElement("button", { type: "button", className: "bi-lg-link", onClick: () => this.transitionTo(state_userentry) }, "Glemt password")));
    }
    onChangeUsername(evt) {
        this.setState({ username: { value: evt.target.value, valid: evt.target.validity.valid } });
    }
    requestOnetimeToken() {
        this.setState({ busy: true });
        FetchHelper.post('/bpapi/forgottenpassword/token', { username: this.state.username.value })
            .then((result) => {
            if (!result.token) {
                return Promise.reject("No token received");
            }
            else {
                this.setState({ state: state_onetimecode, token: result.token, tokenFetchError: false });
            }
        })
            .catch((err) => {
            console.error(err);
            this.setState({ tokenFetchError: true });
        })
            .finally(() => { this.setState({ busy: false }); });
    }
    userEntry() {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(Info, null,
                React.createElement("p", null, "For at \u00E6ndre dit password skal du indtaste dit brugernavn."),
                React.createElement("p", null, "S\u00E5 vil du modtage en sms med en engangskode, som du skal indtaste."),
                React.createElement("p", null, "Derefter vil du f\u00E5 mulighed for at indtaste et nyt password.")),
            (this.state.tokenFetchError) ?
                React.createElement("div", { className: "bi-bv-alert bi-bv-alert-warn", role: "alert" },
                    React.createElement(WarningIcon, null),
                    React.createElement("span", null, "Der kunne ikke dannes en engangskode. Pr\u00F8v eventuelt igen.")) :
                React.createElement(React.Fragment, null),
            React.createElement("div", { className: "bi-lg-entry" },
                React.createElement("input", { type: "text", className: "bi-pf-input", "aria-label": "Brugernavn", placeholder: "Brugernavn", value: this.state.username.value, onChange: (evt) => this.onChangeUsername(evt), pattern: "^.{3,}$", required: true }),
                React.createElement(Go, { busy: this.state.busy, disabled: !(((_a = this.state.username) === null || _a === void 0 ? void 0 : _a.valid) && !this.state.busy), onClick: () => this.requestOnetimeToken() })),
            React.createElement(Back, { onClick: () => this.reset() })));
    }
    onChangeOnetimeCode(evt) {
        // A code that has been refused is gone from the screen as soon as the volunteer starts on another.
        this.setState({ onetimecode: { value: evt.target.value, valid: evt.target.validity.valid }, validationError: false });
    }
    submitOnetimeCode() {
        this.setState({ busy: true });
        FetchHelper.post('/bpapi/forgottenpassword/validate', {
            token: this.state.token,
            onetimeCode: this.state.onetimecode.value
        })
            .then((result) => {
            if (!result.valid) {
                return Promise.reject("Onetime code not valid");
            }
            this.setState({ state: state_newpassword, validationError: false });
        })
            .catch((err) => { this.setState({ validationError: true }); })
            .finally(() => { this.setState({ busy: false }); });
        ;
    }
    onetimeCodeEntry() {
        var _a, _b;
        return (React.createElement(React.Fragment, null,
            React.createElement(Info, null,
                React.createElement("p", null, "Indtast den engangskode, der er sendt som sms.")),
            (this.state.validationError) ?
                React.createElement("div", { className: "bi-bv-alert bi-bv-alert-warn", role: "alert" },
                    React.createElement(WarningIcon, null),
                    React.createElement("span", null, "Engangskoden kunne ikke valideres.")) :
                React.createElement(React.Fragment, null),
            React.createElement("div", { className: "bi-lg-entry" },
                React.createElement("input", { type: "text", className: `bi-pf-input${(((_a = this.state.onetimecode) === null || _a === void 0 ? void 0 : _a.valid) && !this.state.validationError ? ' is-valid' : '')}`, "aria-label": "Engangskode", placeholder: "Engangskode", value: this.state.onetimecode.value, onChange: (evt) => this.onChangeOnetimeCode(evt), pattern: "^[a-zA-Z0-9]{6}$", required: true }),
                React.createElement(Go, { busy: this.state.busy, disabled: !(((_b = this.state.onetimecode) === null || _b === void 0 ? void 0 : _b.valid) && !this.state.busy), onClick: () => this.submitOnetimeCode() })),
            React.createElement(Back, { onClick: () => this.transitionTo(state_userentry, { validationError: false, onetimecode: { value: '', valid: false } }) })));
    }
    passwordChange(evt) {
        switch (evt.target.id) {
            case 'newpassword':
                this.setState({ newpassword: { value: evt.target.value, valid: evt.target.validity.valid }, repeatpassword: { value: '', valid: false } });
                break;
            case 'repeatpassword':
                this.setState({ repeatpassword: { value: evt.target.value, valid: evt.target.value === this.newPasswordRef.current.value && this.newPasswordRef.current.validity.valid } });
                break;
        }
    }
    passwordIsValidAndConfirmed() {
        return this.state.newpassword.valid && this.state.repeatpassword.valid;
    }
    // Something has been typed in the repeat field and it is not the new password. While the
    // volunteer is still typing, a repeat that is the beginning of the password says nothing, so
    // the message does not flash on every keystroke; once they leave the field it has to match.
    repeatMismatch() {
        return repeatMismatch(this.state.newpassword.value, this.state.repeatpassword.value, this.state.repeatLeft);
    }
    submitPassword() {
        this.setState({ busy: true });
        FetchHelper.post('/bpapi/forgottenpassword/newpassword', {
            token: this.state.token,
            onetimeCode: this.state.onetimecode.value,
            password: this.state.newpassword.value
        })
            .then((result) => {
            if (!result.success) {
                return Promise.reject("Password change failed");
            }
            this.setState({ state: state_passwordchanged });
        })
            .catch((err) => { this.setState({ passwordChangeError: true }); })
            .finally(() => { this.setState({ busy: false }); });
    }
    newPassword() {
        return (React.createElement(React.Fragment, null,
            React.createElement(Info, null,
                React.createElement("p", null, "Angiv dit nye password"),
                React.createElement("p", null, "Dit password skal v\u00E6re minimum 10 tegn langt men m\u00E5 gerne v\u00E6re l\u00E6ngere. Det b\u00F8r indeholde en blanding af store og sm\u00E5 bogstaver, tal og specialtegn."),
                React.createElement("p", null, "Et godt password er 12 tegn eller mere, med minimum et tal, et stort bogstav og et specialtegn.")),
            (this.state.passwordChangeError) ?
                React.createElement("div", { className: "bi-bv-alert bi-bv-alert-error", role: "alert" }, "Der opstod en fejl ved angivelse af nyt password.") :
                React.createElement(React.Fragment, null),
            React.createElement("input", { id: "newpassword", type: "password", className: `bi-pf-input${(this.state.newpassword.valid) ? ' is-valid' : ''}`, "aria-label": "Nyt password", placeholder: "Nyt password", value: this.state.newpassword.value, pattern: "^.{10,}$", onChange: (evt) => this.passwordChange(evt), ref: this.newPasswordRef }),
            React.createElement(PasswordStrengthComponent, { password: this.state.newpassword.value }),
            React.createElement("div", { className: "bi-pf-field" },
                React.createElement("input", { id: "repeatpassword", type: "password", className: `bi-pf-input${(this.state.repeatpassword.valid) ? ' is-valid' : ''}${(this.repeatMismatch()) ? ' is-invalid' : ''}`, "aria-label": "Gentag nyt password", "aria-invalid": this.repeatMismatch(), placeholder: "Gentag nyt password", value: this.state.repeatpassword.value, onChange: (evt) => this.passwordChange(evt), onFocus: () => this.setState({ repeatLeft: false }), onBlur: () => this.setState({ repeatLeft: true }) }),
                (this.repeatMismatch()) ?
                    React.createElement("div", { className: "bi-pf-error" }, "De to passwords er ikke ens.") :
                    React.createElement(React.Fragment, null)),
            React.createElement("button", { type: "button", className: "bi-btn bi-btn-save bi-lg-submit", onClick: () => this.submitPassword(), disabled: !this.passwordIsValidAndConfirmed() || this.state.busy }, "Angiv password")));
    }
    passwordChanged() {
        return (React.createElement(React.Fragment, null,
            React.createElement(Info, null,
                React.createElement("p", null, "Dit password er nu \u00E6ndret."),
                React.createElement("p", null, "Tryk p\u00E5 \u201CLog ind\u201D for at logge ind med dit nye password.")),
            React.createElement("button", { type: "button", className: "bi-btn bi-btn-save bi-lg-submit", onClick: () => this.reset() }, "Log ind")));
    }
    render() {
        return (React.createElement("div", { className: "bi-lg" },
            React.createElement("h1", { className: "bi-lg-title" }, titles[this.state.state]),
            React.createElement("div", { className: "bi-card bi-lg-card", id: "login-card" },
                (this.state.state === state_login) ?
                    React.createElement(React.Fragment, null, this.loginState()) :
                    React.createElement(React.Fragment, null),
                (this.state.state === state_userentry) ?
                    React.createElement(React.Fragment, null, this.userEntry()) :
                    React.createElement(React.Fragment, null),
                (this.state.state === state_onetimecode) ?
                    React.createElement(React.Fragment, null, this.onetimeCodeEntry()) :
                    React.createElement(React.Fragment, null),
                (this.state.state === state_newpassword) ?
                    React.createElement(React.Fragment, null, this.newPassword()) :
                    React.createElement(React.Fragment, null),
                (this.state.state === state_passwordchanged) ?
                    React.createElement(React.Fragment, null, this.passwordChanged()) :
                    React.createElement(React.Fragment, null))));
    }
}
ReactRenderer.render("logincomponent", (elem) => React.createElement(LoginComponent, Object.assign({}, (elem.dataset))));
